import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild, inject, output, signal } from '@angular/core';

import { Observable, filter, switchMap, tap } from 'rxjs';

import { CheckboxComponent } from '@camelot/form-input';
import { InputCheckBox } from '@camelot/form-model';
import { FontIconComponent } from '@camelot/icons';
import { CamTenantService } from '@camelot/server';
import { ButtonComponent, EmptyComponent, ErrorComponent, LoaderComponent } from '@camelot/ui';
import { CamBaseComponent, isNonNullable } from '@camelot/utils';

import { Sale } from '../../services/dto/sale';
import { CamSaleService } from '../../services/sale.service';
import { CamTranslationStrapi } from '../../translation.service';
import { RichTextComponent } from '../types/rich-text/rich-text.component';

@Component({
  selector: 'cam-sale',
  templateUrl: './sale.component.html',
  styleUrls: ['./sale.component.scss'],
  imports: [
    CommonModule,
    RichTextComponent,
    LoaderComponent,
    ErrorComponent,
    EmptyComponent,
    ButtonComponent,
    CheckboxComponent,
    FontIconComponent,
  ],
})
export class SaleComponent extends CamBaseComponent implements OnInit {
  @ViewChild('bottomCheckbox') bottomCheckbox!: ElementRef<HTMLElement>;

  acceptation = output<boolean>();

  readonly checkbox = new InputCheckBox({
    label: 'strapi.sale.cguAcceptation',
    toggle: true,
    options: {
      isBold: true,
    },
  });
  readonly content$ = signal<Observable<Sale> | null>(null);

  private _saleService = inject(CamSaleService);
  private _tenantService = inject(CamTenantService);

  constructor() {
    super();
    CamTranslationStrapi.getInstance();
  }

  ngOnInit() {
    this.requestState.asked();

    this._registerSubscription(
      this._tenantService.currentTenantId$
        .pipe(
          filter(isNonNullable),
          tap(tenantId => this.content$.set(this._saleService.saleContents.get$(tenantId.toString()))),
          switchMap(tenantId => this._saleService.fetchSaleContents$(tenantId.toString()))
        )
        .subscribe({
          error: (error: HttpErrorResponse) => this.requestState.onError(error.status, error.statusText),
          next: () => this.requestState.completed(),
        })
    );
  }
  public scrollToBottom() {
    this.bottomCheckbox?.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }
}
